export default {
  label_en: 'HOW WE WORK',
  title: 'AI導入支援の進め方',
  intro: 'ご相談から定着まで、標準的には5つのステップで伴走します。すべてを一度に進める必要はありません。小さく実証し、確かめてから広げる進め方が私たちの基本です。研修や各サービス固有の進め方は、各サービスページの「導入の流れ」をご覧ください。',
  steps: [
    {
      no: '01',
      title: 'ご相談・課題整理',
      badge: '無料',
      desc: '現状の業務と課題をヒアリングで言語化します。「何から手を付けるべきか分からない」段階からで構いません。',
      caseIds: []
    },
    {
      no: '02',
      title: '診断・現状可視化',
      badge: '',
      desc: 'AI活用度診断などを用いて、組織の現在地と課題を数値・チャートで可視化し、取り組みの優先順位を整理します。',
      caseIds: [7]
    },
    {
      no: '03',
      title: 'PoC・小さく実証',
      badge: '',
      desc: '効果が見込める業務に絞り、最小スコープで実現性と効果を検証します。本格投資の判断材料を先に得られます。',
      caseIds: [5, 4]
    },
    {
      no: '04',
      title: '本格導入・開発',
      badge: '',
      desc: '検証で確かめた仕組みを業務システムとして構築し、現場のフローに組み込みます。セキュリティ要件にも対応します。',
      caseIds: [1, 2]
    },
    {
      no: '05',
      title: '定着・内製化支援',
      badge: '',
      desc: '研修と伴走支援で「使いこなせる組織」へ。自社だけで改善を回せる内製化まで見届けます。',
      caseIds: [3, 8]
    }
  ]
};
